import { EpimsBaseEntityDto } from './epim-base.dto';
export class AddressTypeDto extends EpimsBaseEntityDto {

    AddressTypeName: string;
    SubscriptionUserId: string;
    Version: number;
}